import React, { FC } from 'react';
import RoutableNotEditableLink from '../../../../react-only-components/RoutableNotEditableLink';
import { TProductCard } from '../../types/SeriesListing.types';
import SummarySpecs from './SummarySpecs';
import '../../../../styles/@shared/product-card.scss';
import { appendToUrlPath } from '../../../../utils/linkUtils';
import CTAWithArrow from '../../../../react-only-components/CTAWithArrow';

const ProductCard: FC<TProductCard> = (props) => {
  const {
    titleUrl = '',
    title,
    eyebrow = '',
    description,
    summarySpecs,
    button1,
    button2,
    thumbnail,
    thumbnailAlt,
    baseUrl = ''
  } = props;
  

  return (  <article className={`product-card__wrapper ${encodeURI(eyebrow)}`}>
      <a className="product-card" href={appendToUrlPath(baseUrl, titleUrl)}> 
        <div className="product-card__image-wrapper"> 
            <img className="product-card__image" src={thumbnail} alt={thumbnailAlt  || ""}/>
        </div>  
        <div className="product-card__content"> 
          {eyebrow ? <p className="product-card__eyebrow">{eyebrow}</p> : null}
          {title ? <h1 className="product-card__title">{title}</h1> : null}
          {description ? <div className="product-card__description">{description}</div> : null}
          {summarySpecs?.length ? <SummarySpecs summarySpecs={summarySpecs}/> : null}
          <div className="product-card__button-wrapper">
            {button1?.label ? <pfe-cta pfe-priority="primary" class="product-card__button">
              <RoutableNotEditableLink href={button1.url}>
                {button1?.label}
              </RoutableNotEditableLink>
            </pfe-cta> : null }
            {button2?.label ? <CTAWithArrow text={button2?.label} href={button2?.url ?? ''} /> : null }
          </div>
        </div>
      </a>
    </article>);
};

export default ProductCard;
